import { useState } from 'react'
import { Package } from 'react-feather'
import { Badge, Card, CardBody, Col, Row, Table } from 'reactstrap'
import { newFormatThousandSeparator } from 'utils/formatNumber'

const InventoryAnalytics = ({ items }) => {
  const [activeSubTab, setActiveSubTab] = useState('material-inventory') // stage-completion & material-inventory

  // TRANSFORM API DATA TO MATERIAL INVENTORY DATA
  const materialInventoryData = items.map((item) => {
    const coverage = item.goal > 0 ? item.pctgVsGoal : 0
    let status = 'good'

    if (coverage < 50) {
      status = 'critical'
    } else if (coverage < 80) {
      status = 'low'
    }

    return {
      material: item.nameItem,
      available: item.totalInventory,
      required: item.goal,
      coverage: coverage,
      status: status,
      unit: item.unit,
    }
  })

  // TRANSFORM API DATA TO STAGE COMPLETION DATA
  const stageCompletionData = items.map((item) => {
    const completion = item.pctgVsGoal
    let color = '#12B76A'

    if (completion < 50) {
      color = '#F04438'
    } else if (completion < 80) {
      color = '#F79009'
    }

    return {
      name: item.nameItem,
      completion: completion,
      color: color,
    }
  })

  // CALCULATE ANALYTICS DATA FROM ITEMS
  const avgStageCompletion =
    items.length > 0
      ? Math.round(
          items.reduce((sum, item) => sum + item.pctgVsGoal, 0) / items.length,
        )
      : 0

  const criticalMaterials = materialInventoryData.filter(
    (item) => item.status === 'critical',
  ).length

  const analyticsData = {
    avgStageCompletion: avgStageCompletion,
    materialsTracked: items.length,
    criticalMaterials: criticalMaterials,
  }

  const chartOptions = {
    chart: {
      type: 'bar',
      toolbar: {
        show: false,
      },
      height: 350,
    },
    plotOptions: {
      bar: {
        horizontal: false,
        columnWidth: '60%',
        borderRadius: 4,
        distributed: true,
      },
    },
    dataLabels: {
      enabled: false,
    },
    legend: {
      show: true,
      position: 'bottom',
      horizontalAlign: 'center',
      markers: {
        width: 8,
        height: 8,
        radius: 2,
      },
    },
    xaxis: {
      categories: stageCompletionData.map((item) => item.name),
      labels: {
        style: {
          fontSize: '11px',
        },
        rotate: 0,
        trim: true,
      },
    },
    yaxis: {
      min: 0,
      max: 100,
      tickAmount: 4,
      labels: {
        formatter: function (val) {
          return val
        },
      },
    },
    colors: stageCompletionData.map((item) => item.color),
    grid: {
      borderColor: '#f1f1f1',
      strokeDashArray: 4,
    },
    tooltip: {
      y: {
        formatter: function (val) {
          return val + '%'
        },
      },
    },
  }

  const chartSeries = [
    {
      name: 'Completion %',
      data: stageCompletionData.map((item) => item.completion),
    },
  ]

  return (
    <div className="w-100">
      {/* HEADER */}
      {/* <Row className="mb-3">
        <Col xs="12">
          <h6 className="mb-0 fw-semibold">Analytics & Insights</h6>
        </Col>
      </Row> */}

      {/* STATS CARDS */}
      {/* <Row className="g-3 mb-4">
        <Col xs="12" md="4">
          <StatCard
            icon={<TrendingUp size={20} style={{ color: '#006386' }} />}
            iconBgColor="#ECF9FE"
            title="Avg Stage Completion"
            value={`${analyticsData.avgStageCompletion}%`}
          />
        </Col>

        <Col xs="12" md="4">
          <StatCard
            icon={<Package size={20} style={{ color: '#7F56D9' }} />}
            iconBgColor="#F3E8FF"
            title="Materials Tracked"
            value={analyticsData.materialsTracked}
          />
        </Col>

        <Col xs="12" md="4">
          <StatCard
            icon={<AlertCircle size={20} style={{ color: '#F04438' }} />}
            iconBgColor="#FEF3F2"
            title="Critical Materials"
            value={analyticsData.criticalMaterials}
          />
        </Col>
      </Row> */}

      {/* SUB TABS */}
      {/* TEMPORARY HIDE TAB MENU */}
      {/* <Row className="mb-3">
        <Col xs="12">
          <Nav className="border-bottom-0">
            <NavItem>
              <NavLink
                className={`cursor-pointer px-3 py-2 ${
                  activeSubTab === 'stage-completion'
                    ? 'border-bottom border-2'
                    : ''
                }`}
                onClick={() => setActiveSubTab('stage-completion')}
                style={{
                  cursor: 'pointer',
                  borderBottomColor:
                    activeSubTab === 'stage-completion'
                      ? '#006386'
                      : 'transparent',
                  color:
                    activeSubTab === 'stage-completion' ? '#006386' : '#667085',
                  fontWeight:
                    activeSubTab === 'stage-completion' ? '600' : '400',
                  backgroundColor: 'transparent',
                }}
              >
                Stage Completion
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink
                className={`cursor-pointer px-3 py-2 ${
                  activeSubTab === 'material-inventory'
                    ? 'border-bottom border-2'
                    : ''
                }`}
                onClick={() => setActiveSubTab('material-inventory')}
                style={{
                  cursor: 'pointer',
                  borderBottomColor:
                    activeSubTab === 'material-inventory'
                      ? '#006386'
                      : 'transparent',
                  color:
                    activeSubTab === 'material-inventory'
                      ? '#006386'
                      : '#667085',
                  fontWeight:
                    activeSubTab === 'material-inventory' ? '600' : '400',
                  backgroundColor: 'transparent',
                }}
              >
                Material Inventory
              </NavLink>
            </NavItem>
          </Nav>
        </Col>
      </Row> */}

      {/* CHART SECTION */}
      <Row>
        <Col xs="12">
          <Card className="border-0 shadow-sm">
            <CardBody className="p-4">
              {/* {activeSubTab === 'stage-completion' && (
                <>
                  <h6 className="mb-4 fw-semibold">
                    Stage Completion Overview
                  </h6>
                  {stageCompletionData.length > 0 ? (
                    <Chart
                      options={chartOptions}
                      series={chartSeries}
                      type="bar"
                      height={350}
                    />
                  ) : (
                    <div className="text-center py-5 text-muted">
                      <TrendingUp size={48} className="mb-3" />
                      <p>Belum ada data stage completion</p>
                    </div>
                  )}
                </>
              )} */}
              {/* {activeSubTab === 'material-inventory' && (
                <> */}
              {materialInventoryData.length > 0 ? (
                <>
                  <h6 className="mb-4 fw-semibold">
                    Material Inventory Status
                  </h6>
                  <div className="table-responsive">
                    <Table className="align-middle">
                      <thead>
                        <tr style={{ backgroundColor: '#F9FAFB' }}>
                          <th
                            className="border-0 py-3 px-3 fw-semibold"
                            style={{ color: '#344054' }}
                          >
                            Material
                          </th>
                          <th
                            className="border-0 py-3 px-3 fw-semibold text-end"
                            style={{ color: '#344054' }}
                          >
                            Available
                          </th>
                          <th
                            className="border-0 py-3 px-3 fw-semibold text-end"
                            style={{ color: '#344054' }}
                          >
                            Required
                          </th>
                          <th
                            className="border-0 py-3 px-3 fw-semibold text-end"
                            style={{ color: '#344054' }}
                          >
                            Coverage
                          </th>
                          <th
                            className="border-0 py-3 px-3 fw-semibold text-center"
                            style={{ color: '#344054' }}
                          >
                            Status
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {materialInventoryData.map((item, index) => (
                          <tr key={index}>
                            <td className="py-3 px-3 border-bottom">
                              {item.material}
                            </td>
                            <td className="py-3 px-3 border-bottom text-end">
                              {newFormatThousandSeparator(item.available)} {item.unit}
                            </td>
                            <td className="py-3 px-3 border-bottom text-end">
                              {item.required > 0
                                ? `${newFormatThousandSeparator(item.required)} ${item.unit}`
                                : '-'}
                            </td>
                            <td className="py-3 px-3 border-bottom text-end">
                              {newFormatThousandSeparator(item.coverage, 2)}%
                            </td>
                            <td className="py-3 px-3 border-bottom text-center">
                              <Badge
                                color={
                                  item.status === 'critical'
                                    ? 'danger'
                                    : item.status === 'low'
                                      ? 'warning'
                                      : 'success'
                                }
                                className="px-3 py-1"
                                style={{
                                  fontSize: '12px',
                                  fontWeight: '500',
                                  textTransform: 'capitalize',
                                }}
                              >
                                {item.status}
                              </Badge>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </Table>
                  </div>
                </>
              ) : (
                <div className="text-center py-5 text-muted">
                  <Package size={48} className="mb-3" />
                  <p>Belum ada data material inventory</p>
                </div>
              )}
              {/* </>
              )} */}
            </CardBody>
          </Card>
        </Col>
      </Row>
    </div>
  )
}

export default InventoryAnalytics
